<avatar-list [staticAvatar]="_staticAvatar" (selectionChanged)="onSelectAssembly($event)" [type]="'assembly'"
             [enabled]="_enabled" [availableElements]="_assemblies" [placeholder]="'Assembly'"></avatar-list>